import LogsPanelContext from '@crm/contexts/LogsPanelContext'
import * as React from 'react'

import { MailForm } from './MailForm'

export const SendMail = () => {
  const { toggleSendMail } = React.useContext(LogsPanelContext)

  return <MailForm onCloseForm={toggleSendMail} />
}
